export const appHeader = {
    headerSearchBox: false,

    create: function () {
        var that = this;
        this.headerSearchBox = $(".js-desktop-search").html();
        that.bindEvents();
        that.checkSearchBox();
        that.checkBurger();
    },
    //Bind event listeners to elements
    bindEvents: function () {
        var that = this;
        $(document).on("click", ".js-hamburger", function (e) {
            e.preventDefault();
            var isOpen = $(this).attr("aria-expanded") == "true" ? true : false;
            //console.log('ham: ', isOpen);
            if (!isOpen) {
                that.openMainNav();
            } else {
                that.closeMainNav();
            }
        });
        $(document).on("click", ".js-nav-close", function (e) {
            e.preventDefault();
            that.closeMainNav();
        });
        $(document).on(
            "click",
            ".js-main-nav .main-nav-menu-item button",
            function (e) {
                e.preventDefault();
                var navMainItem = $(this).closest(".main-nav-menu-item"),
                    isClosed =
                        $(this).attr("aria-expanded") == "false" ? true : false;
                if (isClosed) {
                    that.openNavSubmenu(navMainItem);
                } else {
                    that.closeNavSubmenu(navMainItem, false);
                }
            }
        );
        $(document).on("click", ".js-location-dd", function (e) {
            e.preventDefault();
            var isOpen = $(this).attr("aria-expanded") == "true" ? true : false;
            if (!isOpen) {
                that.openLocDD();
            } else {
                that.closeLocDD();
            }
        });
        $(document).on("click", ".js-loc-option", function (e) {
            e.preventDefault();
            var mail = $(this).attr("data-email"),
                phone = $(this).attr("data-phone"),
                address = $(this).attr("data-address"),
                selected = $(this).attr("data-selected");
            that.showHeaderContact(mail, phone, address, selected);
        });
        $(document).on("click", function (e) {
            var isLocDD = $('[data-type="location-dd"]').has(e.target).length
                ? true
                : false;
            if (!isLocDD) {
                var locOpen =
                    $(".js-location-dd").attr("aria-expanded") == "false"
                        ? false
                        : true;
                if (locOpen) {
                    that.closeLocDD();
                }
            }
        });
        $(window).on("resize", function () {
            that.checkSearchBox();
        });
        $(document).on("scroll", function () {
            that.checkBurger();
        });

        // Key Combinations
        $(document).on("keydown", function (e) {
            if (e.which == 9) {
                // console.log('Tab');
                if (e.shiftKey) {
                    // Main Submenu
                    var firstLocLink = $(".js-loc-option:first").is(":focus");
                    if (firstLocLink) {
                        e.preventDefault();
                        $(".js-location-dd").eq(0).trigger("focus");
                        that.closeLocDD();
                    }
                    var firstNavLink = $(
                        ".js-main-nav .main-nav-links a:first"
                    ).is(":focus");
                    if (firstNavLink) {
                        e.preventDefault();
                        $(".main-nav-socials a:last").trigger("focus");
                    }
                } else {
                    // Main Submenu
                    var lastLocLink = $(".js-loc-option:last").is(":focus");
                    if (lastLocLink) {
                        e.preventDefault();
                        $(".js-location-dd").eq(0).trigger("focus");
                        that.closeLocDD();
                    }
                    var lastSocLink = $(".main-nav-socials a:last").is(
                        ":focus"
                    );
                    if (lastSocLink) {
                        e.preventDefault();
                        $(".js-main-nav")
                            .find(".nav-favorite")
                            .trigger("focus");
                    }
                }
            } else if (e.which == 13) {
                //console.log('Enter');
            } else if (e.which == 16) {
                //console.log('Shift');
            } else if (e.which == 17) {
                //console.log('Control');
            } else if (e.which == 18) {
                //console.log('Alt');
            } else if (e.which == 27) {
                //console.log('Escape');
                that.closeMainNav();
            } else if (e.which == 32) {
                //console.log('Space');
                var element = $(e.target);
                //console.log('el: ', element);
                if ($(element).is(":button")) {
                    //console.log('button');
                    e.preventDefault();
                    $(element).trigger("click");
                } else if ($(element).is("a")) {
                    //console.log('anchor');
                    e.preventDefault();
                    $(element).trigger("click");
                }
            } else if (e.which == 37) {
                //console.log('Left');
            } else if (e.which == 38) {
                //console.log('Up');
            } else if (e.which == 39) {
                //console.log('Right');
            } else if (e.which == 40) {
                //console.log('Down');
            }
        });
    },
    checkSearchBox: function () {
        var that = this,
            wWidth = $(window).width();
        if (wWidth < 769) {
            $(".js-desktop-search").html("");
            $(".js-mobile-search").html($(this.headerSearchBox));
        } else {
            $(".js-mobile-search").html("");
            $(".js-desktop-search").html($(this.headerSearchBox));
        }
    },
    checkBurger: function () {
        var that = this,
            wScrolled = $(window).scrollTop(),
            wWidth = $(window).width(),
            fixPos = wWidth < 769 ? 60 : 100;
        //console.log('sPos: ', wScrolled);
        if (wScrolled >= fixPos) {
            $(".js-burgerbun").addClass("fixed");
        } else {
            $(".js-burgerbun").removeClass("fixed");
        }
    },
    openLocDD: function () {
        var that = this;
        $(".js-location-dd").attr("aria-expanded", "true");
        $('[data-type="location-dd"]')
            .find(".js-location-dd-menu")
            .attr("aria-hidden", "false");
        $('[data-type="location-dd"]')
            .find(".js-location-dd-menu .location-dd-menu-option")
            .removeAttr("tabindex");
        $(".location-dd-menu-option").eq(0).trigger("focus");
    },
    closeLocDD: function () {
        var that = this;
        $(".js-location-dd").attr("aria-expanded", "false");
        $('[data-type="location-dd"]')
            .find(".js-location-dd-menu")
            .attr("aria-hidden", "true");
        $('[data-type="location-dd"]')
            .find(".js-location-dd-menu .location-dd-menu-option")
            .attr("tabindex", "-1");
        setTimeout(function () {
            $(".js-location-dd").trigger("focus");
        }, 50);
    },
    showHeaderContact: function (mail, phone, address, selected) {
        var that = this,
            contactInfo =
                '<div class="header-contact-info"><a href="mailto:' +
                mail +
                '" class="header-contact-mail"><svg aria-label="mail"><use xlink:href="/images/frontend/main-icons.svg#mail-icon"></use></svg><span>' +
                mail +
                '<span></a><a href="' +
                phone +
                '"class="header-contact-phone"><svg aria-label="phone"><use xlink:href="/images/frontend/main-icons.svg#phone-icon"></use></svg><span>' +
                phone +
                '<span></a><div class="header-contact-address"><span>' +
                address +
                "<span></div></div>";
        $(".js-header-contact").html($(contactInfo));
        $(".js-location-dd span").html(selected);
        $(".js-soloc-dd span").html(selected);
        that.closeLocDD();
    },
    openMainNav: function () {
        var that = this;
        $("body").addClass("no-scroll");
        $(".js-hamburger").attr("aria-expanded", "true");
        $(".js-main-nav").attr("aria-hidden", "false");
        $(".js-main-nav").find(".nav-favorite").removeAttr("tabindex");
        $(".js-main-nav").find(".nav-basket").removeAttr("tabindex");
        $(".js-main-nav").find(".nav-user").removeAttr("tabindex");
        $(".js-nav-close").removeAttr("tabindex");
        $(".js-main-nav")
            .find(".main-nav-cat a")
            .each(function () {
                $(this).removeAttr("tabindex");
            });
        $(".js-main-nav")
            .find(".main-nav-menu-item a")
            .each(function () {
                var isSubmenuItem = $(this).closest(".main-nav-submenu").length;
                if (!isSubmenuItem) {
                    $(this).removeAttr("tabindex");
                } else {
                    var isActive =
                        $(this)
                            .closest(".main-nav-submenu")
                            .attr("aria-hidden") == "true"
                            ? false
                            : true;
                    if (isActive) {
                        $(this).removeAttr("tabindex");
                    }
                }
            });
        $(".js-main-nav")
            .find(".main-nav-menu-item button")
            .each(function () {
                $(this).removeAttr("tabindex");
            });
        setTimeout(function () {
            $(".js-main-nav").find(".nav-favorite").trigger("focus");
        }, 250);
    },
    closeMainNav: function () {
        var that = this;
        $("body").removeClass("no-scroll");
        $(".js-hamburger").attr("aria-expanded", "false");
        $(".js-main-nav").attr("aria-hidden", "true");
        $(".js-main-nav").find(".nav-favorite").attr("tabindex", "-1");
        $(".js-main-nav").find(".nav-basket").attr("tabindex", "-1");
        $(".js-main-nav").find(".nav-user").attr("tabindex", "-1");
        $(".js-nav-close").attr("tabindex", "-1");
        $(".js-main-nav")
            .find(".main-nav-cat a")
            .each(function () {
                $(this).attr("tabindex", "-1");
            });
        $(".js-main-nav")
            .find(".main-nav-menu-item a")
            .each(function () {
                $(this).attr("tabindex", "-1");
            });
        $(".js-main-nav")
            .find(".main-nav-menu-item button")
            .each(function () {
                $(this).attr("tabindex", "-1");
            });
        setTimeout(function () {
            $(".js-hamburger").trigger("focus");
        }, 250);
    },
    openNavSubmenu: function (navMainItem) {
        var that = this,
            allClosed = that.closeNavSubmenu(navMainItem, true),
            subMenu = $(navMainItem).find(".main-nav-submenu"),
            button = $(navMainItem).find("button");
        if (allClosed) {
            $(navMainItem).attr("data-state", "active");
            $(button).attr("aria-expanded", "true");
            $(subMenu).attr("aria-hidden", "false");
            $(subMenu)
                .find(".main-nav-submenu-item a")
                .each(function () {
                    $(this).removeAttr("tabindex");
                });
            setTimeout(function () {
                $(subMenu)
                    .find(".main-nav-submenu-item:first a")
                    .trigger("focus");
            }, 250);
        } else {
            console.error("Submenu Error: closing other submenus failed;");
        }
    },
    closeNavSubmenu: function (navMainItem, open) {
        var that = this;
        $(".js-main-nav")
            .find(".main-nav-menu-item button")
            .each(function () {
                var mainItem = $(this).closest(".main-nav-menu-item"),
                    subMenu = $(mainItem).find(".main-nav-submenu");
                $(mainItem).attr("data-state", "false");
                $(this).attr("aria-expanded", "false");
                $(subMenu).attr("aria-hidden", "true");
                $(subMenu)
                    .find(".main-nav-submenu-item a")
                    .each(function () {
                        $(this).attr("tabindex", "-1");
                    });
            });
        if (!open) {
            setTimeout(function () {
                $(navMainItem).find("button").trigger("focus");
            }, 250);
        }
        return true;
    },
};
